<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-layout pa-6 mt-3 style="background-color: #3E7662;">
              <v-flex
                d-flex
                justify-start
                align-center
                style="font-size: 28px;color: white"
              >
                <div style="font-weight: bold" @click="setData">
                  หนังสือ ยกเว้นการพิจารณาด้านจริยธรรม Exemption
                </div>
              </v-flex>
              <v-flex
                d-flex
                justify-end
                align-center
                style="font-weight: bold;font-size: 13px;color: white"
              >
                <span>RL 03_2560</span>
              </v-flex>
            </v-layout>

            <!-- Start Form -->

            <!-- Start Card 1 -->
            <v-card style="padding: 50px 100px 100px 100px">
              <!-- Logo -->
              <v-layout>
                <v-flex>
                  <img src="../../assets/LogoTh.png" width="124" alt="" />
                </v-flex>
              </v-layout>

              <!-- Header -->
              <v-layout mt-4>
                <v-flex>
                  <div style="font-weight: bold;font-size: 20px;">
                    คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก
                  </div>
                  <div style="font-weight: normal;font-size: 20px;">
                    ชั้น 5 อาคารพระมงกุฎเกล้าเวชวิทยา
                    วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้า
                  </div>
                  <div style="font-weight: normal;font-size: 20px;">
                    317/5ถนน ราชวิถีเขตราชเทวีกรุงเทพฯ 10400 โทรศัพท์, (662)
                    763-4297, (662) 763-4270โทรสาร (662) 354-9011
                  </div>
                  <div style="font-weight: normal;font-size: 20px;">
                    www.irbrta.pmk.ac.th, www.amed.go.th/rtamed/irbrta/ E-mail;
                    irbrta@yahoo.com, irbrta@amed.go.th
                  </div>
                </v-flex>
              </v-layout>

              <!-- divider -->
              <v-layout mt-8>
                <v-flex>
                  <v-divider style="background-color: #544A44;"></v-divider>
                </v-flex>
              </v-layout>

              <!-- No. IRBRTA and Code -->
              <v-layout mt-8>
                <v-flex xs4 d-flex align-center>
                  <!-- No. IRBRTA -->
                  <v-layout>
                    <v-flex shrink pt-5 style="font-weight: bold;">
                      <span>ที่ IRBRTA</span>
                    </v-flex>
                    <v-flex xs4 class="text-field-center">
                      <v-text-field
                        color="#3E7662"
                        v-model="form.IRBTABefore"
                        hide-details
                      />
                    </v-flex>
                    <span class="pt-5" style="font-weight: bold;">/</span>
                    <v-flex xs4 class="text-field-center">
                      <v-text-field
                        color="#3E7662"
                        v-model="form.IRBTAAfter"
                        hide-details
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs4 d-flex align-center>
                  <!-- Code -->
                  <v-layout>
                    <v-flex
                      class="text-end"
                      mr-4
                      pt-2
                      style="font-weight: bold;"
                    >
                      <span>รหัสโครงการ :</span>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="form.code"
                        placeholder="EC"
                        outlined
                        dense
                        color="#3E7662"
                        background-color="#FBF6F3"
                        hide-details
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!-- Form Group -->
              <v-layout py-12 mt-12>
                <v-flex>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ชื่อโครงการวิจัย</span>
                    </v-flex>
                    <v-flex xs6>
                      <textarea-form
                        :model="form.title"
                        style="font-weight: bold"
                        @update-data="updateData('title', $event)"
                      ></textarea-form>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ชื่อผู้ดําเนินการ</span>
                    </v-flex>
                    <v-flex xs6>
                      <textfield-form
                        :model="form.principal"
                        style="font-weight: bold"
                        @update-data="updateData('principal', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>สังกัดหน่วยงาน</span>
                    </v-flex>
                    <v-flex xs6>
                      <textfield-form
                        :model="form.department"
                        style="font-weight: bold"
                        @update-data="updateData('department', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>สถานที่ทําการศึกษา</span>
                    </v-flex>
                    <v-flex xs6>
                      <textfield-form
                        :model="form.studySite"
                        style="font-weight: bold"
                        @update-data="updateData('studySite', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout pl-12 mt-12>
                <v-flex
                  pt-5
                  shrink
                  mr-2
                  style="font-weight: bold;"
                  class="text-start"
                >
                  <div
                    style="text-indent: 20rem;"
                    class="text-field-center text-field-margin"
                  >
                    <span>
                      คณะอนุกรรมการพิจารณาโครงการวิจัย
                      กรมแพทย์ทหารบกได้ทบทวนโครงร่างการวิจัย เรื่อง</span
                    >
                    <span>
                      <v-text-field
                        class="d-inline-block mb-2"
                        style="width: 25rem;"
                        color="#3E7662"
                        hide-details
                        v-model="form.researchName"
                      />
                    </span>
                    <span>ฉบับที่</span>
                    <v-text-field
                      class="d-inline-block mb-2"
                      style="width: 7rem;"
                      color="#3E7662"
                      hide-details
                      v-model="form.version"
                    />
                    <span>วันที่</span>
                    <v-menu
                      v-model="menu_date1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          style="width: 7rem"
                          class="d-inline-block"
                          v-model="dateChange1"
                          readonly
                          item-color="#3E7662"
                          color="#3E7662"
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @input="selectDate($event, 'menu_date1')"
                        locale="th"
                        type="date"
                        color="#3E7662"
                        header-color="#3E7662"
                      ></v-date-picker>
                    </v-menu>
                    <span>
                      และพิจารณาเห็นว่าโครงการวิจัยของท่านเข้าเกณฑ์ได้รับการยกเว้นการพิจารณาด้านจริยธรรมการวิจัย
                      (Exemption)
                      สามารถดําเนินการวิจัยได้โดยไม่ต้องผ่านการพิจารณาด้านจริยธรรมการวิจัยจาก
                      คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก
                      จึงเรียนมาเพื่อทราบ เมื่อวันที่
                    </span>
                    <v-menu
                      v-model="menu_date2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          hide-details
                          style="width: 7rem"
                          class="d-inline-block"
                          v-model="dateChange2"
                          readonly
                          item-color="#3E7662"
                          color="#3E7662"
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @input="selectDate($event, 'menu_date2')"
                        locale="th"
                        type="date"
                        color="#3E7662"
                        header-color="#3E7662"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout
                style="padding-left: 80px; padding-right: 80px;margin-top: 100px"
              >
                <v-spacer></v-spacer>
                <v-flex shrink pt-5 class="text-end">
                  <span style="font-weight: bold;">พันเอก</span>
                </v-flex>
                <v-flex xs5 pl-2 d-flex align-center class="text-end">
                  <v-text-field
                    v-model="form.signature"
                    color="#3E7662"
                    append-icon="edit"
                  />
                </v-flex>
              </v-layout>
              <v-layout style="padding-left: 80px; padding-right: 80px;">
                <v-spacer></v-spacer>
                <v-flex xs5 style="font-weight: bold">
                  <div>(สุธีพานิชกุล)</div>
                  <div>ประธานคณะอนุกรรมการพิจารณาโครงการวิจัย</div>
                  <div>กรมแพทย์ทหารบก</div>
                </v-flex>
              </v-layout>

              <v-layout mt-12>
                <v-flex class="text-start">
                  <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                </v-flex>
              </v-layout>
            </v-card>
            <!--End Card 1 -->

            <!-- End Form -->

            <!-- Button Save -->
            <v-layout mt-8>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      class="mx-4"
                      depressed
                      color="#ffffff"
                      @click.native="$router.go(-1)"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed dark color="#3E7662" @click="save">
                      <!--                                            <v-icon class="mr-3">add</v-icon>-->
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="fullpageAndLine"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";

export default {
  name: "FormRF06",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    menu_date1: false,
    menu_date2: false,
    disabled: false,
    form: {
      researchID: "",
      IRBTABefore: "",
      IRBTAAfter: "",
      code: "",
      title: "",
      principal: "",
      department: "",
      studySite: "",
      researchName: "",
      version: "",
      date: "",
      sendDate: "",
      signature: "",
    },
    dateChange1: "",
    dateChange2: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    //   if (this.user.currentRole !== 4) {
    //       this.$router.go(-1);
    //   }
    this.getRL03();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.$store
            .dispatch("FormRL/saveRL03", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    getRL03() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRL/getRL03", this.$route.query.id)
        .then((res) => {
          this.form.researchID = res.researchID;
          this.form.IRBTABefore = res.IRBTABefore;
          this.form.IRBTAAfter = res.IRBTAAfter;
          this.form.code = res.code;
          this.form.title = res.title;
          this.form.principal = res.principal;
          this.form.department = res.department;
          this.form.studySite = res.studySite;
          this.form.researchName = res.researchName;
          this.form.version = res.version;
          this.selectDate(res.date, "menu_date1");
          this.form.date = res.date;
          this.selectDate(res.sendDate, "menu_date2");
          this.form.sendDate = res.sendDate;
          this.form.signature = res.signature;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    selectDate(val, name) {
      if (name === "menu_date1") {
        this.menu_date1 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange1 = changeDate;
        this.form.date = val;
      }
      if (name === "menu_date2") {
        this.menu_date2 = false;
        // call function changeDate
        let changeDate = this.changeDate(val);
        this.dateChange2 = changeDate;
        this.form.sendDate = val;
      }
    },
    // Change Date
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);

      sub_year = parseInt(sub_year) + 543;

      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    setData() {
      this.form.researchID = "Test";
      this.form.IRBTABefore = "Test";
      this.form.IRBTAAfter = "Test";
      this.form.code = "Test";
      this.form.title = "Test";
      this.form.principal = "Test";
      this.form.department = "Test";
      this.form.studySite = "Test";
      this.form.researchName = "Test";
      this.form.version = "Test";
      this.form.date = "2020-02-12";
      this.form.sendDate = "2020-02-12";
      this.form.signature = "Test";
    },
  },
};
</script>

<style lang="scss">
/*** Table Styles **/
.table-style {
  .table-fill {
    background: white;
    border-radius: 3px;
    border-collapse: collapse;
    margin: auto;
    padding: 5px;
    width: 100%;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    animation: float 5s infinite;
    border-bottom: 5px solid #544a44;
  }

  th {
    color: #d5dde5;
    background: #3e7662;
    border-top: 5px solid #544a44;
    border-right: 1px solid #544a44;
    font-weight: 700;
    padding: 15px;
    vertical-align: middle;
  }

  /*th:first-child {*/
  /*    border-top-left-radius:3px;*/
  /*}*/

  th:last-child {
    border-top-right-radius: 3px;
    border-right: none;
  }

  tr {
    border-top: 1px solid #544a44;
    border-bottom-: 1px solid #544a44;
    color: #ffffff;
  }

  /*tr:hover td {*/
  /*    background:#4E5066;*/
  /*    color:#FFFFFF;*/
  /*    border-top: 1px solid #22262e;*/
  /*}*/

  tr:first-child {
    border-top: none;
  }

  tr:last-child {
    /*border-bottom:5px solid #544A44;*/
  }

  /*tr:nth-child(odd) td {*/
  /*    background:#EBEBEB;*/
  /*}*/

  /*tr:nth-child(odd):hover td {*/
  /*    background:#4E5066;*/
  /*}*/

  tr:last-child td:first-child {
    border-bottom-left-radius: 3px;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 3px;
  }

  td {
    background: #ffffff;
    padding: 10px 30px 10px 30px;
    text-align: left;
    vertical-align: middle;
    font-weight: 700;
    color: black;
    border-right: 1px solid #544a44;
  }

  td:last-child {
    border-right: 0px;
  }

  th.text-left {
    text-align: left;
  }

  th.text-center {
    text-align: center;
  }

  th.text-right {
    text-align: right;
  }

  td.text-left {
    text-align: left;
  }

  td.text-center {
    text-align: center;
  }

  td.text-right {
    text-align: right;
  }
}
.text-field-color {
  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}
.text-field-margin {
  .v-text-field {
    padding-top: 5px;
    padding-bottom: 8px;
    margin: 0;
  }
}
</style>
